<div class="ru-center">
  <div class="ru-card">
    <img class="ru-logo" src="assets/images/logo/logo-large.png" alt="JFL Living">

    <!-- Loading -->
    <div *ngIf="loading" class="ru-loading">
      <span class="ru-spinner"></span>
      <div class="ru-loading-text">Carregando reserva...</div>
    </div>

    <!-- Erro -->
    <div *ngIf="!loading && error" class="ru-error">
      {{ error }}
    </div>

    <!-- Detalhes + Texto + Ações -->
    <ng-container *ngIf="!loading && !error && reserva as r">
      <div class="ru-details">
        <div class="ru-details-row">
          <span class="ru-dt">Nº da reserva</span>
          <span class="ru-dd">{{ r.codigo }}</span>
        </div>
        <div class="ru-details-row">
          <span class="ru-dt">Locatário</span>
          <span class="ru-dd">{{ reserva?.contratoCliente?.locatario?.nome }}</span>
        </div>
        <div class="ru-details-row">
          <span class="ru-dt">Morador principal</span>
          <span class="ru-dd">{{ getMoradorPrincipal(r) }}</span>
        </div>
        <div class="ru-details-row">
          <span class="ru-dt">Empreendimento</span>
          <span class="ru-dd">{{ r.unidade.empreendimento?.nome }}</span>
        </div>
        <div class="ru-details-row">
          <span class="ru-dt">Unidade</span>
          <span class="ru-dd">{{ r.unidade?.numero }}</span>
        </div>
        <div class="ru-details-row">
          <span class="ru-dt">Período</span>
          <span class="ru-dd">
            {{ r.dataEntradaPrevista | date:'dd/MM/yyyy' }} – {{ r.dataSaidaPrevista | date:'dd/MM/yyyy' }}
          </span>
        </div>
      </div>

      <!-- Texto explicativo padrão (só se ainda estiver válido) -->
      <p class="ru-info-text" *ngIf="notificacaoValida">
        Para fins de planejamento e providências operacionais, solicitamos a gentileza de informar sua decisão abaixo,
        indicando se deseja <strong>prorrogar sua reserva</strong> (informando a nova data) ou <strong>encerrá-la</strong>.
      </p>

      <!-- Mensagem de notificação já respondida/expirada -->
      <div class="ru-info-warning" *ngIf="notificacaoValida === false">
        {{ notificacaoMsg || 'Esta solicitação já foi respondida ou não está mais disponível.' }}
      </div>

      <!-- Ações: só quando a notificação ainda está aguardando resposta -->
      <div class="ru-actions" *ngIf="notificacaoValida">
        <button class="ru-btn ru-btn--ghost" (click)="onEncerrar()" [disabled]="loadingEncerrar">
          <span *ngIf="!loadingEncerrar">Encerrar a reserva</span>
          <span *ngIf="loadingEncerrar" class="ru-spinner"></span>
        </button>

        <button class="ru-btn ru-btn--primary" (click)="onProrrogar()" [disabled]="loadingProrrogar">
          <span *ngIf="!loadingProrrogar">Prorrogar a reserva</span>
          <span *ngIf="loadingProrrogar" class="ru-spinner"></span>
        </button>
      </div>
    </ng-container>
  </div>
</div>
